import { Dialog, DialogContent } from '@mui/material'
import { useShareModalContext } from './contexts/shareModal'
import { ModalHeader, SharedTextSection, SongsSelectionSection, ModalActions } from './components'
import { formatShareText } from './utils/shareTextFormatter'

export const ShareModal = () => {
  const {
    open,
    songs,
    selected,
    requestTitle,
    distributionTerritory,
    plannedPublicationDate,
    isLoading,
    sharedUrl,
    sharedPassword,
    handleSelect,
    handleSelectAll,
    handleClose,
    handleShare,
  } = useShareModalContext()

  const handleDeselectAll = () => handleSelectAll(false)
  const selectedSongsDetails = songs.filter(song => selected.includes(song.id))

  const shareText = formatShareText({
    requestTitle,
    distributionTerritory,
    plannedPublicationDate,
    selectedSongs: selectedSongsDetails,
    sharedUrl,
    sharedPassword,
  })

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <ModalHeader onClose={handleClose} />

      <DialogContent sx={{ p: 4 }}>
        {sharedUrl && sharedPassword ? (
          <SharedTextSection shareText={shareText} />
        ) : (
          <SongsSelectionSection songs={songs} selected={selected} onSelect={handleSelect} />
        )}
      </DialogContent>

      <ModalActions
        hasSharedUrl={!!sharedUrl}
        isLoading={isLoading}
        selectedCount={selected.length}
        shareText={shareText}
        onClose={handleClose}
        onDeselectAll={handleDeselectAll}
        onShare={handleShare}
      />
    </Dialog>
  )
}
